class cartMessageController {
    constructor() {
        this.isDismissed = false;
    }

    dismissMessage() {
        this.isDismissed = true;
    }
}

const cartMessageComponentDefinition = {
    controller: cartMessageController,
    bindings: {
        message: '<',
    },
    template: require('./cart-message.component.html').trim(),
};

module.exports = {
    cartMessageController,
    cartMessageComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-message.component.js